import { NewAgentCommissionView } from "../../Views/Home";

export const NewAgentCommissionRoutes = [
  {
    path: "/view",
    name: "AgentCommissionView:agent-commission",
    component: NewAgentCommissionView,
    layout: "/home/agent-commission",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: "AgentCommissionView:agent-commission",
        isDisabled: true,
        route: "/home/agent-commission/view",
        groupName: "accounts",
      },
    ],
  },
];
